export const TASK_NAME_SEARCH_ACCESSOR = "like.name";

export const buildTaskTitleSearchFilter = (searchValue) => ({
  accessor: TASK_NAME_SEARCH_ACCESSOR,
  value: `%${String(searchValue || "").trim()}%`,
});

export const withTaskSearchVars = (variables = {}, filter = {}) => {
  const next = { ...variables };
  if (filter.like) {
    next.like = filter.like;
  }
  if (filter.lt) {
    next.lt = filter.lt;
  }
  if (filter.gt) {
    next.gt = filter.gt;
  }
  return next;
};

export const resolveTaskEmptyMessage = ({
  hasSearch,
  searchEmptyMessage,
  listEmptyMessage,
}) => (hasSearch ? searchEmptyMessage : listEmptyMessage);
